const get = require('lodash/get')

module.exports = location => get(location, 'additionalData.classification') === 'Clinics and Hospitals'
